import type { ProductInfoBoxFeatureConfig } from '../../types/features/ProductInfoBoxFeatureConfig';

export const productInfoBox: ProductInfoBoxFeatureConfig = {
    showContractNumber: false,
    showCurrentInstallment: false,
    showPurchasePrice: false,
    showRemainingTerm: false,
};
